import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {ClassroomKeyValuesStore} from '../../../../../classroom/stores/ClassroomKeyValuesStore';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {McqModel} from '../../models';
import {MultiSelectMcqStore} from '../MultiSelectMcqStore';

interface Props {
  contentSnapshotId: number,
  model: McqModel,
  store: X9ContentStateStore
}

function renderSelectAnswer(key: number, item: McqModel): React.ReactNode {
  const answer = item.choices[key];
  return (
    <div className="teacher-answer" key={'answer' + key}>
      {answer.label}
    </div>
  );
}

function* renderer(store: MultiSelectMcqStore): ReactNodeGenerator {
  const model = store.model;
  if (model.behavior !== 'multi-select')
    return;
  if (store.state === null)
    return;

  for (let index = 0; index < model.choices.length; index++) {
    const choice = model.choices[index];
    const state = store.state.states[index];

    const checked = state.checked;
    const correct = checked && (state.selected === choice.selected);
    const incorrect = checked && (state.selected !== choice.selected);

    const classname = classNames('mcq multi-select', {
      checked: state.selected && state.checked,
      correct: correct,
      incorrect: incorrect
    });
    yield (
      <div className="row" key={index}>
        <div className="col">
          <div className={classname}>
            <div className="form-group">
              <div className="form-check">
                <label className="form-check-label">
                  <input type="checkbox" className="form-check-input"
                         checked={state.selected}
                         onChange={() => store.toggle(index)}
                         disabled={correct}/>
                  {choice.label}
                  {choice.selected && renderSelectAnswer(index, model)}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  yield (
    <div className="row justify-content-end" key="check">
      <div className="col-auto">
        <button className="btn btn-primary" type="button" onClick={store.check}> Check
        </button>
      </div>
    </div>);
}

@observer
export class TeacherMultiSelectMcq extends React.Component<Props> {
  readonly store: MultiSelectMcqStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new MultiSelectMcqStore(props.contentSnapshotId, props.model, props.store);
  }

  render() {
    return Array.from(renderer(this.store));
  }
}
